type NaturalNameSortable = {
  id: string;
  name: string;
};

export function sortByNaturalName<T extends NaturalNameSortable>(
  items: readonly T[],
  locale?: string,
): T[] {
  const naturalCollator = new Intl.Collator(locale, {
    numeric: true,
    sensitivity: 'base',
  });
  const exactCollator = new Intl.Collator(locale, {
    numeric: false,
    sensitivity: 'variant',
  });

  return [...items].sort((left, right) => {
    const naturalComparison = naturalCollator.compare(left.name, right.name);
    if (naturalComparison !== 0) {
      return naturalComparison;
    }

    const exactComparison = exactCollator.compare(left.name, right.name);
    if (exactComparison !== 0) {
      return exactComparison;
    }

    return left.id.localeCompare(right.id);
  });
}
